<div class="pv2-pdv-importer">
  <header class="pv2-pdv-importer__header">
    <div>
      <h2>{{ title }}</h2>
      <p>{{ subtitle }}</p>
    </div>
    <button type="button" class="pv2-pdv-importer__close" (click)="close()">
      <span class="fa fa-times"></span>
    </button>
  </header>

  <section class="pv2-pdv-importer__chooser">
    <div class="pv2-pdv-importer__choice-group">
      <span class="pv2-pdv-importer__choice-label">Editar</span>
      <div class="pv2-pdv-importer__segmented">
        <button type="button"
                class="pv2-pdv-importer__mode-btn"
                [class.is-active]="mode === 'products'"
                (click)="switchMode('products')">
          <span class="fa fa-cube"></span>
          Produtos
        </button>
        <button type="button"
                class="pv2-pdv-importer__mode-btn"
                [class.is-active]="mode === 'options'"
                (click)="switchMode('options')">
          <span class="fa fa-plus-square"></span>
          Adicionais
        </button>
      </div>
    </div>

    <div class="pv2-pdv-importer__choice-group">
      <span class="pv2-pdv-importer__choice-label">Forma</span>
      <div class="pv2-pdv-importer__segmented pv2-pdv-importer__segmented--soft">
        <button type="button"
                class="pv2-pdv-importer__mode-btn"
                [class.is-active]="editorMode === 'upload'"
                (click)="switchEditorMode('upload')">
          <span class="fa fa-file-alt"></span>
          Planilha
        </button>
        <button type="button"
                class="pv2-pdv-importer__mode-btn"
                [class.is-active]="editorMode === 'manual'"
                (click)="switchEditorMode('manual')">
          <span class="fa fa-edit"></span>
          Manual
        </button>
      </div>
    </div>
  </section>

  <section class="pv2-pdv-importer__help" *ngIf="!usingManualEditor">
    <div>
      <strong *ngIf="!usingManualEditor">Formato esperado</strong>
      <strong *ngIf="usingManualEditor">Edição manual</strong>

      <p *ngIf="!usingManualEditor && mode === 'products'">`produto;código` ou `#id;código`</p>
      <p *ngIf="!usingManualEditor && mode === 'options'">`produto;adicional;opção;código` ou usando `#id` nas referências</p>
      <p *ngIf="!usingManualEditor && mode === 'options'">Se o adicional for compartilhado entre produtos, a opção será atualizada em todos eles.</p>

      <p *ngIf="usingManualEditor && mode === 'products'">
        Clique em <b>{{ manualEmptyActionLabel }}</b>, filtre a lista e edite apenas os produtos que precisar.
      </p>
      <p *ngIf="usingManualEditor && mode === 'options'">
        Clique em <b>{{ manualEmptyActionLabel }}</b>, filtre por produto, adicional ou opção e ajuste os códigos direto na tela.
      </p>
      <p *ngIf="usingManualEditor && mode === 'options'">
        Quando o adicional for compartilhado, uma única linha manual atualiza todos os produtos vinculados.
      </p>
    </div>

    <div class="pv2-pdv-importer__examples" *ngIf="!usingManualEditor; else manualTips">
      <span>Exemplos</span>
      <code *ngFor="let line of exampleLines">{{ line }}</code>
    </div>
  </section>

  <ng-template #manualTips>
    <div class="pv2-pdv-importer__examples">
      <span>Dicas</span>
      <code>Use a busca para localizar por nome, categoria, produto, adicional, opção ou código</code>
      <code>Ative "Somente alterados" para revisar só o que foi mexido</code>
      <code>O botão final salva apenas as linhas com status Pronto</code>
    </div>
  </ng-template>

  <ng-container *ngIf="!usingManualEditor">
    <section class="pv2-pdv-importer__input">
      <div class="pv2-pdv-importer__input-head">
        <div class="pv2-pdv-importer__input-actions">
          <button type="button"
                  class="pv2-pdv-importer__download-btn"
                  [disabled]="!canDownloadTemplate || loadingOptionIndex"
                  (click)="downloadTemplate()">
            <span class="fa fa-download"></span>
            {{ downloadTemplateLabel }}
          </button>

          <label class="pv2-pdv-importer__file">
            <input type="file" accept=".csv,.txt" (change)="onFileSelected($event)">
            <span class="fa fa-file-upload"></span>
            Importar arquivo
          </label>
        </div>

        <button type="button"
                class="pv2-pdv-importer__preview-btn"
                [disabled]="loadingOptionIndex"
                (click)="buildPreview()">
          <span class="fa fa-search" *ngIf="!loadingOptionIndex"></span>
          <span class="fa fa-spinner fa-spin" *ngIf="loadingOptionIndex"></span>
          Gerar prévia
        </button>
      </div>

      <textarea [(ngModel)]="rawInput"
                rows="10"
                placeholder="Cole aqui a lista com um item por linha..."></textarea>
    </section>

    <section class="pv2-pdv-importer__summary" *ngIf="previewItems.length">
      <span class="pv2-pdv-importer__pill is-ready">{{ readyCount }} prontos</span>
      <span class="pv2-pdv-importer__pill is-unchanged">{{ unchangedCount }} sem alteração</span>
      <span class="pv2-pdv-importer__pill is-overridden" *ngIf="overriddenCount">{{ overriddenCount }} substituídos</span>
      <span class="pv2-pdv-importer__pill is-error" *ngIf="issueCount">{{ issueCount }} com erro</span>
    </section>

    <section class="pv2-pdv-importer__preview" *ngIf="previewItems.length; else emptyPreview">
      <div class="pv2-pdv-importer__table-wrap">
        <table class="pv2-pdv-importer__table">
          <thead>
          <tr>
            <th>Linha</th>
            <th>Item</th>
            <th>Atual</th>
            <th>Novo</th>
            <th>Status</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let item of previewItems" [class]="statusClass(item.status)">
            <td>{{ item.lineNumber }}</td>
            <td>
              <strong>{{ item.label }}</strong>
              <small>{{ item.message }}</small>
            </td>
            <td>{{ item.currentCode || '-' }}</td>
            <td>{{ item.nextCode || '-' }}</td>
            <td>
              <span class="pv2-pdv-importer__status" [class]="statusClass(item.status)">
                {{ statusLabel(item.status) }}
              </span>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </section>

    <ng-template #emptyPreview>
      <section class="pv2-pdv-importer__empty">
        <span class="fa fa-list-alt"></span>
        <p>Monte a lista e clique em <b>Gerar prévia</b> para validar antes de salvar.</p>
      </section>
    </ng-template>
  </ng-container>

  <ng-container *ngIf="usingManualEditor">
    <section class="pv2-pdv-importer__manual">
      <div class="pv2-pdv-importer__manual-head">
        <div>
          <strong *ngIf="mode === 'products'">Produtos do catálogo</strong>
          <strong *ngIf="mode === 'options'">Adicionais do catálogo</strong>
          <p *ngIf="mode === 'products'">Carregue a lista completa e edite os códigos PDV diretamente na tabela.</p>
          <p *ngIf="mode === 'options'">Carregue as opções de adicionais e ajuste os códigos sem precisar importar planilha.</p>
        </div>

        <button type="button"
                class="pv2-pdv-importer__download-btn"
                [disabled]="loadingOptionIndex"
                (click)="loadManualItems()">
          <span class="fa fa-spinner fa-spin" *ngIf="loadingOptionIndex"></span>
          <span class="fa fa-list" *ngIf="!loadingOptionIndex"></span>
          {{ manualLoadLabel }}
        </button>
      </div>

      <ng-container *ngIf="manualItemsLoaded; else manualEmpty">
        <div class="pv2-pdv-importer__manual-toolbar">
          <input class="pv2-pdv-importer__search-input"
                 type="text"
                 [(ngModel)]="manualSearch"
                 [placeholder]="manualSearchPlaceholder">

          <div class="pv2-pdv-importer__manual-filters">
            <label class="pv2-pdv-importer__toggle">
              <input type="checkbox" [(ngModel)]="manualOnlyWithoutCode">
              <span>Somente sem código</span>
            </label>

            <label class="pv2-pdv-importer__toggle">
              <input type="checkbox" [(ngModel)]="manualOnlyChanged">
              <span>Somente alterados</span>
            </label>
          </div>
        </div>

        <section class="pv2-pdv-importer__summary">
          <span class="pv2-pdv-importer__pill is-unchanged">{{ manualLoadedCount }} carregados</span>
          <span class="pv2-pdv-importer__pill is-overridden">{{ manualChangedCount }} alterados</span>
          <span class="pv2-pdv-importer__pill is-ready" *ngIf="manualReadyCount">{{ manualReadyCount }} prontos</span>
          <span class="pv2-pdv-importer__pill is-error" *ngIf="manualInvalidCount">{{ manualInvalidCount }} com erro</span>
        </section>

        <section class="pv2-pdv-importer__preview" *ngIf="filteredManualItems.length; else manualNoResults">
          <div class="pv2-pdv-importer__table-wrap">
            <table class="pv2-pdv-importer__table">
              <thead>
              <tr>
                <th>Item</th>
                <th>Atual</th>
                <th>Novo</th>
                <th>Status</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let item of filteredManualItems" [class]="statusClass(item.status)">
                <td>
                  <strong>{{ item.label }}</strong>
                  <small>{{ item.subtitle }}</small>
                </td>
                <td>{{ item.currentCode || '-' }}</td>
                <td>
                  <input class="pv2-pdv-importer__code-input"
                         type="text"
                         [ngModel]="item.nextCode"
                         (ngModelChange)="updateManualCode(item, $event)"
                         placeholder="Informe o código PDV">
                  <small>{{ item.message }}</small>
                </td>
                <td>
                  <span class="pv2-pdv-importer__status" [class]="statusClass(item.status)">
                    {{ statusLabel(item.status) }}
                  </span>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </section>
      </ng-container>
    </section>

    <ng-template #manualEmpty>
      <section class="pv2-pdv-importer__empty">
        <span class="fa fa-edit"></span>
        <p>Clique em <b>{{ manualEmptyActionLabel }}</b> para abrir a edição manual nesta mesma tela.</p>
      </section>
    </ng-template>

    <ng-template #manualNoResults>
      <section class="pv2-pdv-importer__empty">
        <span class="fa fa-search"></span>
        <p>Nenhum item encontrado com os filtros atuais.</p>
      </section>
    </ng-template>
  </ng-container>

  <footer class="pv2-pdv-importer__footer">
    <button type="button" class="pv2-pdv-importer__ghost" (click)="close()">
      Fechar
    </button>
    <button type="button"
            class="pv2-pdv-importer__primary"
            [disabled]="!canApply"
            (click)="apply()">
      <span class="fa fa-spinner fa-spin" *ngIf="applying"></span>
      <span class="fa fa-save" *ngIf="!applying"></span>
      Aplicar códigos
    </button>
  </footer>
</div>
